import { Component, OnInit, Injector, Input,  } from '@angular/core';
import {  BaseComponent } from "../../base.component";
import { isEmpty, includes } from 'lodash';

@Component ({
    selector: 'insert-number',
    template: `
  <control
    [control]="control.attributes.input"
    [context]="context">
  </control>

  <control 
    [control]="control.attributes.button"
    [context]="context">
  </control>

    `,
    styleUrls: ['./insert-number.component.scss']
})

export class InsertNumberComponent extends BaseComponent implements OnInit {
 constructor (injector : Injector) {
   super(injector);
 }

 ngOnInit() {

 }

 
}